import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js"

import ky from 'ky'

import Memory from 'memory/memory.js'

export class Game {

    constructor (play, mpcheck, mpplayer, ctx) {

        this.ctx = ctx

        this.played = false

        this.config = {
            mpcheck: mpcheck,
            mpplayer: mpplayer,
            play: play
        }
        this.win = {
            i: 0,
            r: 0
        }
        const el = document.getElementById('memory')
        if (el) {

            this.game = new Memory(el)
            this.game.el.addEventListener('game.end', ()=>this.endGame())

            this.startButton = document.getElementById('btn-start')
            this.startDialog = document.getElementById('dialog-start')
            this.endDialog = document.getElementById('dialog-end')
            this.loginDialog = document.getElementById('dialog-login')
            this.winDialog;

            this.verifyPlayer()
        }
    }

    async verifyPlayer () 
    {
        const url = `/api/player/${this.config.mpcheck}?mpplayer=${this.config.mpplayer}`
        const data  = await ky.get(url).json()

        this.config.play = data.success

        this.start()

        window.dispatchEvent(new CustomEvent('user.verified'))
    }

    start () 
    {

        if (this.config.play) {

            // Create scroll trigger
            ScrollTrigger.create({
                trigger: "#section-game",
                start: "top center",
                end: "bottom bottom",
                onEnter: () => this.initGame()
            });

            let offset = window.outerWidth < 600 ? 0 : 0

            gsap.to(window, {
                scrollTo: {
                    duration: 0.75, 
                    y: '#section-game',
                    offsetY: offset,
                    delay: 0.5
                },
                ease: "power4"
            });

        } else {

            ScrollTrigger.create({
                trigger: "#section-game",
                start: "top center",
                end: "bottom bottom",
                onEnter: () => {
                    gsap.fromTo(this.loginDialog,{
                        scale: 0,
                        opacity: 0,
                        display: 'block'
                    },{
                        delay: 0.5,
                        scale: 1,
                        opacity: 1,
                        duration: 0.75,
                        ease: 'bounce.out'
                    })
                }
            });
        }
    }

    initGame() 
    {
        if (!this.played) {
            this._acivateStartBtn()
        }
    }

    endGame() 
    {
        if (this.win.r > 0) {

            this.winDialog = document.querySelector(`[data-reward="${this.win.r}"]`)

            // Show winner text
            this.confirmPlayer()
                .then(()=>{            
                    gsap.fromTo(this.winDialog,{
                        scale: 0,
                        opacity: 0,
                        display: 'block'
                    },{
                        scale: 1,
                        opacity: 1,
                        duration: 0.75,
                        ease: 'bounce.out'
                    })

                })

        } else {

            this.confirmPlayer()
                .then(()=>{
                    gsap.fromTo(this.endDialog,{
                        scale: 0,
                        opacity: 0,
                        display: 'block'
                    },{
                        scale: 1,
                        opacity: 1,
                        duration: 0.75,
                        ease: 'bounce.out'
                    })
                })
        }
    }

    async confirmPlayer () 
    {
        const params = new URLSearchParams();
        params.set('mpcheck', this.config.mpcheck);
        params.set('ctx', this.ctx);

        await ky.put('/api/player', {body: params})
    } 

    async startGame ()
    {
        const formData = new FormData
        formData.append('mpplayer', this.config.mpplayer)
        formData.append('mpcheck', this.config.mpcheck)
        const data = await ky.post('/api/player', {body: formData}).json()

        if (data.success) {
            this.win = data.object
            window.dispatchEvent(new CustomEvent('game.start'))
        }
    }

    _scrollInViewport () 
    {
        const gameSection = document.getElementById('section-game')

        if (gameSection.clientHeight > window.innerHeight) {

            const rect = gameSection.getBoundingClientRect()
            const top = rect.top + window.scrollY
            const yPos = top + gameSection.clientHeight - window.innerHeight

            gsap.to(window, {
                scrollTo: {
                    duration: 0.3, 
                    y: yPos
                },
                ease: "power3"
            });
        }

    }

    _acivateStartBtn() 
    {
        const startBtnClickHandler = (e) => {
            const button = e.currentTarget
            e.preventDefault()

            button.removeEventListener('click', startBtnClickHandler)

            if (!this.played) {

                this._scrollInViewport()
                this.played = true

                gsap.to(this.startDialog, {
                    scale: 0,
                    duration: 0.5,
                    ease: 'power3',
                    onComplete: () => {
                        this.startDialog.style.display = 'none'
                        this.startGame()
                            .then(()=>{
                                this.game.start(this.win)
                            })
                    }
                })
            }
        }

        gsap.fromTo(this.startDialog, {
            scale: 0,
            display: 'flex'
        },{
            scale: 1,
            duration: 1.2,
            ease: 'bounce.out'
        })

        this.startButton
            .addEventListener('click', startBtnClickHandler)

        const btnEffect = gsap.fromTo(this.startButton, {
                scale: 1
            },{
                scale: 1.2,
                duration: 0.25,
                ease: 'power3',
                paused: true
        })


        this.startButton
            .addEventListener('mouseenter', (e)=>{
                btnEffect.play()
            })

        this.startButton
            .addEventListener('mouseleave', (e)=>{
                btnEffect.reverse()
            })

    }

}